import React from 'react';
import { menu } from '@stereoagency/sanity-schema';
import { MenuLocation, defaultLanguage } from '@stereoagency/constants';
import { $globalSanityClient } from '@/sanity';
import { waterfallFetch } from '@/utils';
import UIFooter from './Footer.client';

type Props = {
  lang: string;
};

const menuQuery = menu.schema.builder
  .filter('language == $language && location == $location')
  .first()
  .use();
type MenuQueryType = (typeof menuQuery)[1] | null;

export default async function Footer({ lang }: Props) {
  const primaryMenu = await waterfallFetch(
    [lang, defaultLanguage.id],
    (current) =>
      $globalSanityClient.fetch<MenuQueryType>(menuQuery[0], {
        language: current,
        location: MenuLocation.FOOTER_PRIMARY
      })
  );

  const secondaryMenu = await waterfallFetch(
    [lang, defaultLanguage.id],
    (current) =>
      $globalSanityClient.fetch<MenuQueryType>(menuQuery[0], {
        language: current,
        location: MenuLocation.FOOTER_SECONDARY
      })
  );

  const legalMenu = await waterfallFetch(
    [lang, defaultLanguage.id],
    (current) =>
      $globalSanityClient.fetch<MenuQueryType>(menuQuery[0], {
        language: current,
        location: MenuLocation.FOOTER_LEGAL
      })
  );

  const moreMenu = await waterfallFetch(
    [lang, defaultLanguage.id],
    (current) =>
      $globalSanityClient.fetch<MenuQueryType>(menuQuery[0], {
        language: current,
        location: MenuLocation.FOOTER_MORE
      })
  );

  const actionsMenu = await waterfallFetch(
    [lang, defaultLanguage.id],
    (current) =>
      $globalSanityClient.fetch<MenuQueryType>(menuQuery[0], {
        language: current,
        location: MenuLocation.FOOTER_ACTIONS
      })
  );

  const socialMenu = await waterfallFetch(
    [lang, defaultLanguage.id],
    (current) =>
      $globalSanityClient.fetch<MenuQueryType>(menuQuery[0], {
        language: current,
        location: MenuLocation.FOOTER_SOCIAL
      })
  );

  return (
    <UIFooter
      primaryMenu={primaryMenu}
      secondaryMenu={secondaryMenu}
      actionsMenu={actionsMenu}
      moreMenu={moreMenu}
      socialMenu={socialMenu}
      legalMenu={legalMenu}
    />
  );
}
